export type QrDesignMode = "preset" | "custom";

export type QrPresetId = "classic" | "minimal" | "elegant";

export interface QrPlacement {
  leftPercent: number;
  topPercent: number;
  sizePercent: number;
}

export interface QrPresetTemplate {
  id: QrPresetId;
  labelKey: string;
  descriptionKey: string;
  previewClass: string;
  defaultPlacement: QrPlacement;
}

export const DEFAULT_QR_PLACEMENT: QrPlacement = {
  leftPercent: 32,
  topPercent: 58,
  sizePercent: 36,
};

export const QR_PRESET_TEMPLATES: QrPresetTemplate[] = [
  {
    id: "classic",
    labelKey: "qrTemplateClassic",
    descriptionKey: "qrTemplateClassicDesc",
    previewClass: "qr-template-preview--classic",
    defaultPlacement: { leftPercent: 32, topPercent: 58, sizePercent: 36 },
  },
  {
    id: "minimal",
    labelKey: "qrTemplateMinimal",
    descriptionKey: "qrTemplateMinimalDesc",
    previewClass: "qr-template-preview--minimal",
    defaultPlacement: { leftPercent: 33, topPercent: 56, sizePercent: 34 },
  },
  {
    id: "elegant",
    labelKey: "qrTemplateElegant",
    descriptionKey: "qrTemplateElegantDesc",
    previewClass: "qr-template-preview--elegant",
    defaultPlacement: { leftPercent: 30, topPercent: 62, sizePercent: 40 },
  },
];
export function clampPlacement(
  placement: QrPlacement,
  aspectRatio: number = 210 / 297
): QrPlacement {
  const sizePercent = Math.min(60, Math.max(8, placement.sizePercent));
  const verticalSizePercent = sizePercent * aspectRatio;
  const leftPercent = Math.min(100 - sizePercent, Math.max(0, placement.leftPercent));
  const topPercent = Math.min(
    100 - verticalSizePercent,
    Math.max(0, placement.topPercent)
  );

  return { leftPercent, topPercent, sizePercent };
}

export function placementToFormFields(placement: QrPlacement) {
  const clamped = clampPlacement(placement);

  return {
    qrLeftPercent: clamped.leftPercent.toString(),
    qrTopPercent: clamped.topPercent.toString(),
    qrSizePercent: clamped.sizePercent.toString(),
  };
}